import { alpha, styled, TextField } from "@mui/material"
import { designTokens } from "@/theme"


export const ThemeTextField = styled(TextField)(({ theme }) => {
    const sel = theme.palette.custom.selection
    return {
    minHeight: '76px',
    width: '100%',
    margin: '0 !important',
    '&:has(.MuiInputBase-sizeSmall)': {
        minHeight: '64px',
        '& input': {
            fontSize: theme.typography.pxToRem(14),
        },
        '& .MuiSelect-select': {
            fontSize: theme.typography.pxToRem(14),
        },
    },
    '& .MuiFormHelperText-root': {
        marginTop: '-2px',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        fontSize: theme.typography.pxToRem(12),
    },
    '& .MuiOutlinedInput-root': {
        borderRadius: `${designTokens.shape.borderRadius.lg}px`,
        borderWidth: '1px',
        '&.Mui-focused': {
            '& .MuiOutlinedInput-notchedOutline': {
                borderWidth: '2px',
                borderColor: `${sel.focusOutline} !important`,
            },
            '& input, & select': {
                fontWeight: 500,
            },
            '& .MuiInputAdornment-positionStart': {
                color: sel.text,
            }
        },

        '& .MuiOutlinedInput-notchedOutline': {
        },
        '& input': {
            fontSize: theme.typography.pxToRem(16),
            // Prevent overlong pasted values from expanding the layout horizontally.
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '100%',
            '&[type=number]': {
                MozAppearance: 'textfield',
                '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                    WebkitAppearance: 'none',
                    margin: 0,
                },
            },
            '&:focus:valid': {
                // color: theme.palette.success.main,
            },
            '&:focus:invalid': {
                color: theme.palette.warning.main,
            },
            '&:focus:valid + fieldset': {
                borderRadius: `${designTokens.shape.borderRadius.lg}px`,
            },
            '&:invalid + fieldset': {
                borderRadius: `${designTokens.shape.borderRadius.lg}px`,
            },
            '&:-webkit-autofill': {
                WebkitTextFillColor: theme.palette.text.primary,
                WebkitBoxShadow: `0 0 0px 1000px ${theme.palette.background.default} inset`,
            },
        },
        '& fieldset': {
            borderWidth: '2px',
            borderRadius: `${designTokens.shape.borderRadius.lg}px`,
            '&:hover': {
                borderWidth: '1px',
                borderRadius: `${designTokens.shape.borderRadius.lg}px`,
            }
        },
        '&.Mui-disabled fieldset': {
            background: alpha(theme.palette.text.disabled, 0.1),
        },
        '&.Mui-focused fieldset': {
            borderWidth: '2px',
        },
        '&.Mui-error fieldset': {
            borderRadius: `${designTokens.shape.borderRadius.lg}px`,
            borderColor: `${theme.palette.error.main} !important`,
        },
    },
    '& .MuiOutlinedInput-input.Mui-disabled': {
        WebkitTextFillColor: theme.palette.text.secondary,
    },
    '& .MuiSelect-select': {
        fontSize: theme.typography.pxToRem(16),
        paddingBlock: '7px !important',
    },
    '&:has(input[type="file"])': {
        '& .Mui-focused fieldset': {
            background: 'transparent !important',
        },
        "& .MuiOutlinedInput-root *:not(svg)": {
        },
    },
    '&:has(svg, input[type="file"])': {
        '& .MuiOutlinedInput-root *:not(svg)': {
            //     borderWidth: '1px',
        },
        '&.Mui-focused .MuiOutlinedInput-root': {
            //    borderWidth: '2px',
        },
    },
    '& .MuiOutlinedInput-root input::-webkit-file-upload-button': {
        fontSize: theme.typography.body1.fontSize,
        borderRadius: `${designTokens.shape.borderRadius.xl}px`,
        background: sel.surfaceSolid,
        border: `2px solid ${sel.borderStrong}`,
        color: sel.textOnSolid,
    },
    '& input[type="date"]': {
        '&::-webkit-calendar-picker-indicator': {
            // display: 'none',
            // WebkitAppearance: 'none',
            // appearance: 'none',
            // MozAppearance: 'textfield',
        },
        '&::placeholder': {
            color: 'transparent',
        },
        '&:not(:focus):not(:valid)': {
            color: 'transparent',

        }
    },
    '&:has(input[type="search"])': {
        minHeight: 'auto !important',
        '& .MuiOutlinedInput-root': {
            borderRadius: `${designTokens.shape.borderRadius.lg}px !important`,
            backgroundColor: `${theme.palette.background.paper} !important`,
            boxShadow: `0 4px 14px ${alpha(theme.palette.text.primary, 0.06)} !important`,
            border: 'none !important',
            minHeight: '48px !important',
            padding: '0 16px !important',
            '& fieldset': {
                border: 'none !important',
                borderRadius: `${designTokens.shape.borderRadius.lg}px !important`,
            },
            '&.Mui-focused fieldset': {
                border: 'none !important',
            },
        },
        '& .MuiOutlinedInput-input': {
            padding: '12px 8px 12px 0 !important',
            fontSize: theme.typography.pxToRem(15),
        },
    },
}; })